import React, { useState, useEffect } from "react";
import { Row, Col, Select, Form, Input, Checkbox } from "antd";
import { connect } from "react-redux";

import QADynamicTable from "../../../../components/qa_custom/DynamicTable";
import { selectDataFromExecQuery } from "../../actions/funcional.group";
import { getColumnSearchProps } from "../search.into.table.columns";

const { Option } = Select;
const EXEC_QUERY_NAME = {
    parametros_comp_grupos_func: "parametros_comp_grupos_func",
    tipos_param_comportam: "tipos_param_comportam",
};

const Behavior = ({
    form,
    selectDataFromExecQuery, //from redux action
    soma_ponderacao_paramcomp,
    selectedGrupoExist,
    idGrupoExist,
    set_parametro_comportamental,
    parametro_comportamental,
    setBehavoirPonderationCalculeValue,
}) => {
    const { getFieldDecorator } = form;

    const [dataSource, setDataSource] = useState([]);
    const [behaviorTypes, setBehaviorTypes] = useState([]);
    const [sumPonderation, setSumPonderation] = useState(false);
    // const [ponderationCalculeValue, setPonderationCalculeValue] = useState(undefined);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (parametro_comportamental.length) {
            setDataSource(parametro_comportamental);
            setSumPonderation(!sumPonderation);
        }
    }, []);

    /**
     * do ponderation calcule
     */
    useEffect(() => {
        const sum = dataSource
            .filter((item) => item["ativo"] === "t")
            .map((item) => Number(item.ponderacao))
            .reduce((a, b) => a + b, 0);
        setBehavoirPonderationCalculeValue(sum);
    }, [sumPonderation]);

    /**
     * fetch "parametros comportamentais" from group exist
     */
    // useEffect(() => {
    //     if (selectedGrupoExist || idGrupoExist) {
    //         (async () => {
    //             setLoading(true);
    //             const response = await selectDataFromExecQuery({
    //                 query: EXEC_QUERY_NAME.parametros_comp_grupos_func,
    //                 id_ficha_funcao: idGrupoExist || 0,
    //                 sel_grupo_exist: selectedGrupoExist,
    //             });
    //             if (response.result) {
    //                 if (Array.isArray(response.result)) {
    //                     const data = [];
    //                     response.result.forEach((item, index) => {
    //                         data.push({ __key__: index, ...item });
    //                     });
    //                     await setDataSource(data);
    //                     set_parametro_comportamental(data);
    //                     setSumPonderation(!sumPonderation); // forcing calculate ponderation
    //                 }
    //             }
    //             setLoading(false);
    //         })();
    //     }
    // }, [selectedGrupoExist, idGrupoExist]);

    /**
     * fetch "tipos parametros comportamentais"
     */
    useEffect(() => {
        (async () => {
            setLoading(true);
            const response = await selectDataFromExecQuery({
                query: EXEC_QUERY_NAME.tipos_param_comportam,
            });
            if (response.result) {
                if (Array.isArray(response.result)) {
                    setBehaviorTypes(response.result);
                }
            }
            setLoading(false);
        })();
    }, []);

    /**
     * add row to table
     */
    const addRowToTable = () => {
        let size = dataSource.length > 0 ? Math.max(...dataSource.map((item) => Number(item.__key__))) + 1 : 0;
        setDataSource([{ __key__: size }, ...dataSource]);
    };

    /**
     * remove row from table
     */
    const removeRowFromTable = (selectedRowKeys) => {
        const newDataSource = [];
        dataSource.forEach((item) => {
            if (!selectedRowKeys.includes(item.__key__)) newDataSource.push(item);
        });
        setDataSource(newDataSource);
        setSumPonderation(!sumPonderation);
    };

    /**
     * handle change when user enter degit
     */
    const onChange = async (dataIndex, value, record) => {
        const newState = [...dataSource];

        record[dataIndex] = value;
        const index = newState.findIndex((item) => item.__key__ === record.__key__);
        newState.splice(index, 1, record);
        // newState[index] = record;

        await setDataSource([...newState]);

        set_parametro_comportamental([...newState]);

        if (dataIndex === "ponderacao" || dataIndex === "ativo") {
            setSumPonderation(!sumPonderation);
        }
    };

    /**
     * columns to table
     */
    const columns = [
        {
            title: "Tipo comportamento",
            dataIndex: "tipo_parametros_comportam",
            width: "60%",
            ...getColumnSearchProps("tipo_parametros_comportam"),
            onFilter: (value, record) => {
                const filteredValue = behaviorTypes
                    .filter((item) => item.designacao.toString().toLowerCase().includes(value.toLowerCase()))
                    .map((item) => item.tipo_parametros_comportam);
                return filteredValue.includes(record["tipo_parametros_comportam"]);
            },
            render: (text, record) => {
                const defaultValue = typeof text !== "object" && text ? text : undefined;

                return (
                    <Select
                        showSearch
                        allowClear
                        dropdownMatchSelectWidth={false}
                        style={{ maxWidth: "600px", margin: "0 auto", padding: "0" }}
                        placeholder="Seleciona uma opção"
                        optionFilterProp="children"
                        value={behaviorTypes
                            .map((element) => element.tipo_parametros_comportam)
                            .find((item) => item === defaultValue)}
                        onChange={(value) => {
                            onChange("tipo_parametros_comportam", value, record);
                        }}
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {behaviorTypes.map((item) => (
                            <Option key={item.tipo_parametros_comportam} value={item.tipo_parametros_comportam}>
                                {item.designacao}
                            </Option>
                        ))}
                    </Select>
                );
            },
        },
        {
            title: "Ponderação",
            dataIndex: "ponderacao",
            width: "20%",
            ...getColumnSearchProps("ponderacao"),
            render: (text, record) => (
                <Form.Item style={{ width: "100%", margin: "0 auto", padding: "0" }}>
                    <Input
                        onChange={(e) => onChange("ponderacao", e.target.value, record)}
                        type="number"
                        defaultValue={typeof text !== "object" ? text : undefined}
                        style={{ width: "100%" }}
                        placeholder="Introduza a ponderação"
                    />
                </Form.Item>
            ),
        },
        {
            title: "Ativo?",
            dataIndex: "ativo",
            width: "10%",
            align: "center",
            ...getColumnSearchProps("ativo"),
            render: (text, record) => (
                <Checkbox
                    onChange={(e) => onChange("ativo", e.target.checked === true ? "t" : "f", record)}
                    defaultChecked={text === "t" || text === true}
                />
            ),
        },
    ];

    return (
        <>
            {/* <Row>
                <Col xs={24} sm={6}>
                    <Form.Item label="Ponderação na dimensão">
                        {getFieldDecorator("soma_ponderacao_paramcomp", {
                            initialValue: ponderationCalculeValue,
                        })(
                            <Input
                                readOnly
                                type="number"
                                size="small"
                                style={{ width: "100%" }}
                                placeholder="Ponderação na dimensão"
                            />
                        )}
                    </Form.Item>
                </Col>
            </Row> */}
            <QADynamicTable
                data={dataSource}
                columns={columns}
                addRowToTable={addRowToTable}
                onRemoveItem={removeRowFromTable}
                loadingData={loading}
            />
        </>
    );
};

const mapDispatchToProps = {
    selectDataFromExecQuery,
};

export default connect(null, mapDispatchToProps)(Behavior);
